import React from "react";
import "./TopBar.scss"
import { Link, Navigate, useLocation } from "react-router-dom";
import api from "../../veracityapi";
import bApi from "../../API/BeaconAPI";
import moment from "moment";
import { useDispatch } from "react-redux";
import { detectModes } from "Redux/actions";
import { IoMenu } from "react-icons/io5";

const TopBar = () => {
	const timeZone = localStorage.getItem('timezone');
	const websiteName = localStorage.getItem("websiteName");
	const isPartner = localStorage.getItem("isPartner") === "true";
	const isAdmin = localStorage.getItem("admin") === "true";
	const [switchAccountToggle, setSwitchAccountToggle] = React.useState(false);
	const [myAccountToggle, setMyAccountToggle] = React.useState(false);
	const [helpToggle, setHelpToggle] = React.useState(false);
	const [time, setTime] = React.useState(moment()?.tz(timeZone)?.format("HH:mm:ss"));
	const date = moment().tz(timeZone)?.format("Do MMM YYYY");
	const [switchWebsite, setSwitchWebsite] = React.useState(false);
	const { pathname } = useLocation();
	const numbersOfWebsites = localStorage.getItem("websitesNumber");
	const numbersOfCustomers = localStorage.getItem("customersNumber");
	const admin = localStorage.getItem("admin") === "true";
	const websiteToggleRef = React.useRef(null);
	const myAccountToggleRef = React.useRef(null);
	const helpRef = React.useRef(null);
	const isAFPEnabled = localStorage.getItem("isAFPEnabled") == "true";
	const dispatch = useDispatch();

	React.useEffect(() => {
		let intervalId;
		if (timeZone !== undefined || timeZone !== null) {
			intervalId = setInterval(() => {
				setTime(moment()?.tz(timeZone)?.format('HH:mm:ss'));
			}, 500);
		}
		return () => clearInterval(intervalId);
	}, [timeZone]);


	function handleSwitchAccount() {
		// if(admin){
		// 	localStorage.setItem("isPartner", false);
		// }		
		dispatch(detectModes({
			wtp_status: "off",
			afp_status: "off"
		}));
		// api.setCustomerGUID(null);
		// bApi.logout();
		// api.setWebsiteGUID(null);
		// bApi.setWebsiteId(null);
		setSwitchWebsite(!switchWebsite);
	};

	function handleWebsiteToggle() {
		setSwitchAccountToggle(!switchAccountToggle)
	};

	function handleMyAccountToggle() {
		setMyAccountToggle(!myAccountToggle)
	};

	const handleOutsideClick = (event) => {
		if (websiteToggleRef.current && !websiteToggleRef.current.contains(event.target)) {
			setSwitchAccountToggle(false);
		};
		if (myAccountToggleRef.current && !myAccountToggleRef.current.contains(event.target)) {
			setMyAccountToggle(false)
		}
		if (helpRef.current && !helpRef.current.contains(event.target)) {
			setHelpToggle(false)
		}
	};

	React.useEffect(() => {
		document.addEventListener('click', handleOutsideClick);
		return () => {
			document.removeEventListener('click', handleOutsideClick);
		};
	}, []);

	React.useMemo(() => {
		if (pathname === "/loading") {			
			setSwitchWebsite(false)
		}
	}, [pathname]);

	if (switchWebsite) {
		return (
			<Navigate
				to={{
					pathname: "/select",
				}}
			/>
		)
	};

	if (pathname === "/" || pathname === "/loading" || pathname === "/select") {
		return null
	};

	const renderCompanyMenuItem = () => {
		return (
			<Link to='/manage/company' className="links">
				<div className={pathname === '/manage/company' ? "icon-box-active" : "icon-box"}>Company</div>
			</Link>
		);
	}

	let timezoneNoUnderscore = timeZone?.replace("_", " ");

	const renderPartnerMenuItem = () =>{
		if(!isPartner) return (<></>);

		return (<Link to='/manage/partners' className="links isPartner">
			<div className={pathname === "/manage/partners" ? "icon-box-active" : "icon-box"}>Partner Manager</div>
		</Link>);
	}
	
	
	let adminIdText = "";
	if(admin){
		const adminAP_ID = bApi.getWebsiteId();
		const adminWebsiteId = localStorage.getItem("website_id");
		adminIdText += `(${adminWebsiteId ?? 0} / ${adminAP_ID ?? 0})`;
	};

	return (
		<>
		<div className="topbar-margin-fix"></div>
		<div className="topbar">
			<div className="clock">
				<p className="website-name">{websiteName} {adminIdText}</p>
				<p className="time">{time} </p>
				<p className="date">{date}</p>
				<p className="timeZone">{timezoneNoUnderscore}</p>
			</div>
			<div className="spacer"></div>
			<div className="user-account">
				<IoMenu className="menu-icon" size={30} />
				{renderPartnerMenuItem()}
				{renderCompanyMenuItem()}

				{(numbersOfWebsites === "1" && numbersOfCustomers === "1" && !isPartner && !isAdmin) ?
					<Link to='/manage/website' className="links">
						<div className={pathname === "/manage/website" ? "icon-box-active" : "icon-box"}>Website</div>
					</Link>

					:
					<div ref={websiteToggleRef} className={pathname === "/manage/website" ? "icon-box-active" : "icon-box"} onClick={handleWebsiteToggle}>
						Website
						{switchAccountToggle &&
							<div className="menu">
								<Link to='/manage/website' className="links menuItem">
									<div className="switch-toggle-data">View/Edit</div>
								</Link>
								<div className="switch-toggle-data menuItem" onClick={handleSwitchAccount} >Switch Website</div>
							</div>
						}
					</div>
				}
				{isAFPEnabled ?
					<div ref={helpRef} className={pathname === '/help' ? "icon-box-active" : "icon-box"} onClick={() => setHelpToggle(!helpToggle)}>Help
						{helpToggle &&
						<div className="help-toggle menu">
							<Link to='/help' className="links menuItem">
								<div className="switch-toggle-data">FAQ</div>
							</Link>
							<Link to="help/dynamic-links" className="links menuItem">
								<div className="switch-toggle-data" >Dynamic Links</div>
							</Link>
							<Link to="help/bot-types" className="links menuItem">
								<div className="switch-toggle-data" >Bot Types</div>
							</Link>
						</div>
					}
					</div> 
				:
					<Link to="/help" className="links">
						<div className={pathname === '/help' ? "icon-box-active" : "icon-box"}>Help</div>
					</Link>
				}

				<div ref={myAccountToggleRef} className={pathname === '/manage/user' ? "icon-box-active" : "icon-box"} onClick={handleMyAccountToggle}>
					Settings
					{myAccountToggle &&
						<>
							<div className="me-toggle-triangle menu">
								<Link to='/manage/user' className="links menuItem">
									<div className="switch-toggle-data">View/Edit</div>
								</Link>
								<div className="switch-website menuItem" onClick={api.logout}> Sign Out</div>
							</div>
						</>
					}
				</div>

				
			</div>
		</div>
		</>
	);
};

export default TopBar;
